import { getBrowserDisplayName } from "features/gpuDetection/browserDisplayName";

/**
 * Whether an engine failure means "this browser cannot run the viewer", which is only
 * true of Safari on the desktop.
 *
 * iOS and iPadOS are excluded deliberately. Every browser there is WebKit underneath, and
 * the Procore mobile app serves a page the engine does start on, so an engine failure on a
 * handheld is not Safari's fault — and "use a different browser" is not advice the user
 * can act on. Those users get the generic engine copy and a Reload.
 *
 * @param isAppleHandheld - `isIpad || isIphone` from `utils/misc`. Passed in rather than
 * imported here because those constants sniff the user agent once, when the module is
 * first imported, which leaves a test no way to vary them.
 */
export function isUnsupportedSafari(isAppleHandheld: boolean): boolean {
    return getBrowserDisplayName() === "Safari" && !isAppleHandheld;
}
